import React, {useState,useContext,createContext,useEffect,useRef,}  from 'react'
import {Form,Button,Container,Card,Alert,Modal,Navbar,Row,Col,Table} from 'react-bootstrap'
import axios from 'axios'
import {UserContext} from '../UserContext'
import uuid from 'react-uuid'

export default function Items() {



    const {accountingData,setAccountingData}=useContext(UserContext)
    const {catalogueData,setCatalogueData}=useContext(UserContext)
    const {activeTab,setActiveTab}=useContext(UserContext)
    const {exhibition,setExhibition}=useContext(UserContext)
    const [show,setShow]=useState(false)
    const {items,setItems}=useContext(UserContext)
    const [itemsLocal,setItemsLocal]=useState([])
    const [grandTotal,setGrandTotal]=useState(0)
    const {sendForm}=useContext(UserContext)
    const {tempData}=useContext(UserContext)
    


    const handleClose=()=>{
        setShow(false)
    }

    useEffect(()=>{
        //console.log(exhibition)
        if (tempData.items){
            var xitems=items
            xitems.forEach(xitem=>{
                if (tempData.items.filter(tempItem=>tempItem.GXCODE==xitem.GXCODE).length>0){
                    xitem.quantity=tempData.items.filter(tempItem=>tempItem.GXCODE==xitem.GXCODE)[0].quantity
                    xitem.totalPrice=tempData.items.filter(tempItem=>tempItem.GXCODE==xitem.GXCODE)[0].totalPrice

                }
            })
            setItems(xitems)
        }
        

    },[activeTab,exhibition])


    const loadexhibitionsItems=(excode)=>{
        console.log(process.env.REACT_APP_API+'items/'+excode.split('-')[1])
        axios.get(process.env.REACT_APP_API+'items/'+excode.split('-')[1],{
          headers: {
              'Authorization': 'Bearer '+process.env.REACT_APP_TOKEN
          }            
        }).then(res=>{
            const theItems=res.data.filter(item=>item.GXSTRINGFIELD7==1)
            setItems(theItems)
            //console.log(res.data)
        })
    }

    const changeQuantity=(quantity,GXCODE)=>{
        const xitems=[...items]

        xitems.forEach(item=>{
            if (item.GXCODE==GXCODE){
                item.quantity=quantity
                item.totalPrice=quantity*item.PRICE.toFixed(2)
            }
        })

        setItems([...xitems])
    }

    const itemsList=items.map((item,index)=>{
        //if (item.GXCODE.substring(0,2)!='27'){
            return(
                <>
                <tr>
                    <td>{item.GXDESCRIPTION} // {item.GXDESCRIPTIONENG}</td>
                    <td align="right">{item.PRICE}</td>
                    <td align="center">{item.Unit}</td>
                    <td width="10%"><Form.Control type="number" value={item.quantity} min={0} step={0.1} onChange={(e)=>changeQuantity(e.target.value,item.GXCODE)}/></td>
                    <td align="right">{item.totalPrice.toFixed(2)}</td>
                </tr>
                {/* <Card key={index}>
                <Card.Body>
                <Card.Text>
                <Row>
                    <Col><font size="3"><b>{item.GXDESCRIPTION} // {item.GXDESCRIPTIONENG}</b></font></Col>
                    <Col>
                    
                    </Col>

                </Row>
                
                </Card.Text>
                </Card.Body>
                </Card>
                <br/> */}

                </>
            )
        //}
    })





    return (
        <Container fluid>
        <>

        <Alert variant='success'>
          <h4>ΠΕΡΙΓΡΑΦΕΣ ΧΩΡΩΝ // TYPES OF STAND</h4>
          </Alert>
          <Form.Group className="mb-3">
            <Form.Label><b>ΠΕΡΙΠΤΕΡΟ ΠΟΥ ΠΡΟΤΙΜΑΤΕ / PREFERRED PAVILLION </b></Form.Label>
            <Form.Control maxLength={64} type="text" value={catalogueData.Pav}  onChange={(e)=>{setCatalogueData({...catalogueData, Pav:e.target.value.toUpperCase()})}}   />
          </Form.Group> 

            <h4>
                {exhibition.Notes}
                

                {exhibition.HasDoc==1 &&
                <>
                &nbsp;|&nbsp;
                <a href={'https://api.helexpo.gr/exhibitiondocs/'+exhibition.GLX_ExCode+'-GR.pdf'} target="_blank">ΤΥΠΟΙ STAND - ΠΛΗΡΟΦΟΡΙΕΣ (Εκπτώσεις κλπ) (pdf)</a>
                &nbsp;|&nbsp;
                <a href={'https://api.helexpo.gr/exhibitiondocs/'+exhibition.GLX_ExCode+'-ENG.pdf'} target="_blank">STAND TYPES - INFO (Discounts etc)(pdf)</a>
                </>
                }
            </h4>
          <Table striped bordered hover>
                <thead>
                    <tr>
                    <th></th>
                    <th>Τιμή Μονάδας/Unit Price (€)</th>
                    <th>Μονάδα Μέτρησης/Unit of Measure</th>
                    <th>Ποσότητα/Quantity</th>
                    <th>Σύνολο/Total (€)</th>
                    </tr>
                </thead>
                <tbody>
                    {itemsList}
                </tbody>
            </Table>


          <>  
            <br/><br/><br/><br/>
            <Navbar bg="light" fixed="bottom" >
                <table width="100%"><tbody><tr>
                  
                  <td align="left">
                    {accountingData.CMTIN && 
                      <Button variant="secondary" onClick={()=>sendForm(1)}>ΠΡΟΣΩΡΙΝΗ ΑΠΟΘΗΚΕΥΣΗ // TEMPORARY SAVE</Button>
                    }
                
  
              </td>  <td align="right">
                <Button  variant="secondary" onClick={()=>{window.scroll(0,0);setActiveTab('exhibits')}}>ΠΙΣΩ // BACK</Button>
                &nbsp;
                <Button onClick={()=>{window.scroll(0,0);setActiveTab('finish')}} variant="success">ΕΠΟΜΕΝΟ // NEXT</Button>
                </td></tr></tbody></table>
            </Navbar> 
            </>
        </>



        </Container>
  
    )
}
